import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { t } from 'utils/getLiteral';
import Select from 'components/Select';

const BoolSelect = (props) => {
    const { optionLabels, ...rest } = props;

    const yesNoOptions = useMemo(
        () => [
            {
                label: optionLabels && optionLabels.yes ? t(optionLabels.yes) : t('cfm_label_yes'),
                value: true,
            },
            {
                label: optionLabels && optionLabels.no ? t(optionLabels.no) : t('cfm_label_no'),
                value: false,
            },
        ],
        [optionLabels],
    );

    return <Select {...rest} options={yesNoOptions} />;
};

BoolSelect.propTypes = {
    optionLabels: PropTypes.shape({
        yes: PropTypes.string,
        no: PropTypes.string,
    }),
};

export default BoolSelect;
